import React from 'react';

import { Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useRecordContext } from 'react-admin';

import {
    getLifecycleColor,
    getLifecycleStatus,
    LIFECYCLE_LABELS,
} from './StatsHeader';

const LifecycleStatusField = (props) => {
    const record = useRecordContext(props) || props?.record;
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    if (!record) {
        return null;
    }

    const status = getLifecycleStatus(record);
    const color = getLifecycleColor(status, isDark, theme);

    return (
        <Chip
            size="small"
            label={LIFECYCLE_LABELS[status]}
            sx={{ bgcolor: color, color: '#fff' }}
        />
    );
};

export default LifecycleStatusField;
